import React from 'react';

interface Props {
  className?: string;
  fill?: string;
}

const Squares: React.FC<Props> = ({
  className = '',
  fill = '#48535C',
}: Props) => (
  <svg
    className={className}
    fill="none"
    height="20"
    viewBox="0 0 20 20"
    width="20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_62_113)">
      <path
        d="M0 0H4V1.25H10V0H14V5H13V8.75H14V13.75H10V12.5H4V13.75H0V8.75H1V5H0V0ZM11 5H10V3.75H4V5H3V8.75H4V10H10V8.75H11V5ZM10 18.75V20H6V15H7H9H10V16.25H16V15H17V11.25H16V10H15V7.5H16V6.25H20V11.25H19V15H20V20H16V18.75H10Z"
        fill={fill}
      />
    </g>
    <defs>
      <clipPath id="clip0_62_113">
        <rect fill="white" height="20" width="20" />
      </clipPath>
    </defs>
  </svg>
);

export default Squares;
